import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { FdoAccessRulesKeyEnum } from './fdo-access-rules-key.enum';
import { FdoAccessRulesConst } from './fdo-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class FdoAccessService extends BaseAccessService<FdoAccessRulesKeyEnum> {
  public constructor() {
    super(FdoAccessRulesConst);
  }

  public get fdoRights() {
    return {
      canReadKKT: this.globalService.isAccessRule(FdoAccessRulesConst[FdoAccessRulesKeyEnum.FDO_FDO_KKT_READ]),
      canWriteKKT: this.globalService.isAccessRule(FdoAccessRulesConst[FdoAccessRulesKeyEnum.FDO_FDO_KKT_WRITE]),

      canReadReceipt: this.globalService.isAccessRule(FdoAccessRulesConst[FdoAccessRulesKeyEnum.FDO_FDO_RECEIPT_READ]),
      canWriteReceipt: this.globalService.isAccessRule(
        FdoAccessRulesConst[FdoAccessRulesKeyEnum.FDO_FDO_RECEIPT_WRITE]
      ),

      canReadKKTActivity: this.globalService.isAccessRule(
        FdoAccessRulesConst[FdoAccessRulesKeyEnum.FDO_FDO_KKT_ACTIVITY_READ]
      ),

      canReadActivity: this.globalService.isAccessRule(
        FdoAccessRulesConst[FdoAccessRulesKeyEnum.FDO_FDO_ACTIVITY_READ]
      ),
      canWriteActivity: this.globalService.isAccessRule(
        FdoAccessRulesConst[FdoAccessRulesKeyEnum.FDO_FDO_ACTIVITY_WRITE]
      )
    };
  }
}
